export const LOADER_STATUS = 'boilerplate/NewEwayBill/NewEwayBillTab/LOADER_STATUS';
export const TABLE_DATA = 'boilerplate/NewEwayBill/NewEwayBillTab/TABLE_DATA';
export const TOTAL_PAGES = 'boilerplate/NewEwayBill/NewEwayBillTab/TOTAL_PAGES';
export const TOTAL_RECORDS = 'boilerplate/NewEwayBill/NewEwayBillTab/TOTAL_RECORDS';
export const EWAY_RES_TABLE_DATA = 'boilerplate/NewEwayBill/NewEwayBillTab/EWAY_RES_TABLE_DATA';
export const EWAY_ITEM_ERROR_DATA = 'boilerplate/NewEwayBill/NewEwayBillTab/EWAY_ITEM_ERROR_DATA';
export const GENERATE_PART_B_DATA = 'boilerplate/NewEwayBill/NewEwayBillTab/GENERATE_PART_B_DATA';
export const TRANSPORTER_ID_DATA = 'boilerplate/NewEwayBill/NewEwayBillTab/TRANSPORTER_ID_DATA';
export const UPDATE_VEHICLE_DATA = 'boilerplate/NewEwayBill/NewEwayBillTab/UPDATE_VEHICLE_DATA';
export const EXTEND_VALIDITY = 'boilerplate/NewEwayBill/NewEwayBillTab/EXTEND_VALIDITY';

export const defaultEwayRes = {
    'name':'Error',
    'desc':'Error in Eway Response'
}
